export const EXPENSE_CATEGORIES = [
  "ads",
  // Google Ads money spent on tests (new campaigns, experiments), kept apart
  // from "ads" so the month shows how much went to testing (owner, 2026-11-01).
  "ads_testing",
  "backlinks",
  "salaries",
  "software",
  "provider_payouts",
  "office",
  "travel",
  "taxes",
  "other",
] as const;
export type ExpenseCategory = (typeof EXPENSE_CATEGORIES)[number];

export const EXPENSE_PAYMENT_METHODS = ["cash", "bank_transfer", "card", "other"] as const;
export type ExpensePaymentMethod = (typeof EXPENSE_PAYMENT_METHODS)[number];

/**
 * Category spend for a month fixed in code, by owner rule. It wins over a
 * figure typed in on the Expenses page, and the page offers no edit for it.
 *
 * October 2026 Google Ads (owner, 2026-11-01): Google billed 22,891 MAD
 * against 24,000 of top-ups. 4,466 of it is testing, the ad groups under 0%
 * ROI that month (L'Octave 342, Favela Chic 386, Yemaya 663, Folk 893,
 * O'Mammy Burger 508, Anzar 749, and Kamounya, Little Italy, Wauw, Omazonia,
 * Palais Sebban, Ameera and Table du Marché together 925). The rest, 18,425,
 * is regular Google Ads.
 */
export const FIXED_MONTH_SPEND: readonly { month: string; category: ExpenseCategory; amountMad: number }[] = [
  { month: "2026-10", category: "ads", amountMad: 18425 },
  { month: "2026-10", category: "ads_testing", amountMad: 4466 },
];

export function isFixedMonthSpend(month: string, category: string): boolean {
  return FIXED_MONTH_SPEND.some((f) => f.month === month && f.category === category);
}
